<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="cap-wrapper">
    <div class="cap-row">
        <div class="cap-box">
            <div class="cap-image">
                <div class="icon-wrapper">
                    <img width="65" height="57" src="../../../../assets/icon-file-encryption.svg" loading="lazy"
                         alt="Generic file encryption image">
                </div>
            </div>
            <div class="cap-content-wrapper">
                <h2 class="cap-title">File Encryption</h2>
                <div class="cap-subtitle">On any Windows PC or Virtual Machine</div>
                <div class="cap-content">
                    Files are protected on PCs, when synced to clouds, or if users inadvertently
                    share them with unintended parties. Users can securely share encrypted files
                    with others or easily decrypt them before sending. Files include an organization
                    key so colleagues can seamlessly work on files together.
                </div>
            </div>
        </div>
        <div class="cap-box">
            <div class="cap-image">
                <div class="icon-wrapper">
                    <img width="64" height="62" src="../../../../assets/secure-file-share.png" loading="lazy"
                        alt="Generic secure file share image">
                </div>
            </div>
            <div class="cap-content-wrapper">
                <h2 class="cap-title">Secure File Sharing</h2>
                <div class="cap-subtitle">On any Windows PC or Virtual Machine</div>
                <div class="cap-content">
                    Files remain encrypted, only accessible by trusted users, wherever they go.
                    Protect all file types: Office, Adobe, CAD, images, applications – any file.
                    Users easily share files outside the organization by adding individuals or
                    groups to the file’s trusted user list.
                </div>
            </div>
        </div>
    </div>
    <div class="cap-row">
        <div class="cap-box">
            <div class="cap-image">
                <div class="icon-wrapper">
                    <img width="60" height="60" src="../../../../assets/zero-trust-data.svg" loading="lazy"
                        alt="Generic zero trust data image">
                </div>
            </div>
            <div class="cap-content-wrapper">
                <div class="cap-title">Zero Trust File Access</div>
                <div class="cap-subtitle">On any Windows PC or Virtual Machine</div>
                <div class="cap-content">
                    File access controls prevent zero-day ransomware and data exfiltration with
                    file-level MFA. Critical files always require MFA and all other encrypted
                    files only when threats are detected. Access files online and offline with
                    PIN, fingerprint, facial recognition, CAC/PIV, and authenticator apps.
                </div>
            </div>
        </div>
        <div class="cap-box">
            <div class="cap-image">
                <div class="icon-wrapper">
                    <img width="57" height="65" src="../../../../assets/icon-keep-alive.png" loading="lazy"
                        alt="Generic keep alive image">
                </div>
            </div>
            <div class="cap-content-wrapper">
                <div class="cap-title">Keep-alive Heartbeat</div>
                <div class="cap-subtitle">On any Windows PC or Virtual Machine</div>
                <div class="cap-content">
                    File filter driver that prevents file access if Cigent software is disabled. Protects
                    files against advanced remote data theft and ransomware attacks. Automatically makes
                    encrypted files inaccessible if Cigent is not running properly.
                </div>
            </div>
        </div>
    </div>
    <div class="cap-row">
        <div class="cap-box">
            <div class="cap-image">
                <div class="icon-wrapper">
                    <img width="71" height="59" src="../../../../assets/invisible-data.png" loading="lazy"
                         alt="Generic invisible data image">
                </div>
            </div>
            <div class="cap-content-wrapper">
                <div class="cap-title">Invisible Data</div>
                <div class="cap-subtitle">PC with Opal Drive</div>
                <div class="cap-content">
                    Data is invisible, even after logging on until unlocked with MFA. Storage
                    firmware renders data unreadable at the sector level, preventing all physical
                    and remote attacks. Drive can be configured with pre-boot authentication (PBA),
                    rendering the O/S partition invisible.
                </div>
            </div>
        </div>
        <div class="cap-box">
            <div class="cap-image">
                <div class="icon-wrapper">
                    <img width="55" height="65" src="../../../../assets/tamper-proof.svg" loading="lazy"
                         alt="Generic tamper proof image">
                </div>
            </div>
            <div class="cap-content-wrapper">
                <div class="cap-title">Tamper-Proof Credentials</div>
                <div class="cap-subtitle">PC with Opal Drive</div>
                <div class="cap-content">
                    A novel approach to the creation and storage of credentials that make credential
                    access impossible. Cryptographically derived from a user-supplied password.
                    Never stored in their final form. Use the maximum length allowed by the drive.
                </div>
            </div>
        </div>
    </div>
</div>
